import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var sizeIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "m23.17 11.4-3.09-7.21a1 1 0 0 1 .57-1.44l-.09-.18a1.05 1.05 0 0 0-1.83 0 2.28 2.28 0 0 0 0 2.2l.55 1.27c.82 1.92-1.77 5.47-6.94 7.69S2.79 15.39 2 13.47 3.73 8 8.9 5.78a12.74 12.74 0 0 1 4.82-1.13c1.17 0 2 .31 2.2.8s-.09 1.29-.92 2.14a12.65 12.65 0 0 1-4.18 2.75 6.89 6.89 0 0 1-2.59.66c-.65 0-.93-.17-1-.26s0-.4.48-.87A7 7 0 0 1 10 8.33L9.4 7a8.28 8.28 0 0 0-2.78 1.8c-1.1 1.17-1 2.06-.77 2.49s.74 1.16 2.34 1.17a8.47 8.47 0 0 0 3.22-.74 14.3 14.3 0 0 0 4.67-3.1c1.26-1.35 1.7-2.68 1.23-3.77s-1.73-1.68-3.57-1.7A13.85 13.85 0 0 0 8.31 4.4C2.69 6.82-.7 11.06.58 14.06c.05.1 2.55 5.94 2.55 5.94.74 1.71 2.81 2.59 5.5 2.59a17.69 17.69 0 0 0 6.82-1.54 17.19 17.19 0 0 0 6.29-4.4c1.58-1.87 2.09-3.73 1.43-5.25ZM21 15.17l-.43-.92a1 1 0 0 0-1.31-.54l-.46.19 1.1 2.52a14.4 14.4 0 0 1-2.42 1.89l-.92-2.24a1 1 0 0 0-1.31-.54l-.46.19 1.38 3.33c-.42.22-.85.43-1.3.62s-1 .4-1.49.57l-.75-1.75a1 1 0 0 0-1.32-.49l-.46.2 1.07 2.51a14 14 0 0 1-3.09.43l-1.09-2.59A1 1 0 0 0 6.42 18l-.46.2L7.14 21a3.28 3.28 0 0 1-2.63-1.57l-1.37-3.2a9 9 0 0 0 2.94.45 17.64 17.64 0 0 0 6.82-1.55c3.73-1.6 6.47-4 7.52-6.33l1.37 3.2c.37.83.07 2-.79 3.17Z",
  fill: "currentColor"
}));

export { sizeIcon as default };
//# sourceMappingURL=sizeIcon.js.map
